var appsettings = [
    


        /* PRODUCTION */
        {key: "glasschain.app.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},     
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-west-b7azgtemaebzdgh6.westus-01.azurewebsites.net"},
        //{key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-east.azurewebsites.net"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-west-c4e7fhggh6c7e2gf.westus-01.azurewebsites.net"},
        //{key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-east.azurewebsites.net"},
        {key: "glasschain.core.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.address.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.translation.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.textrecognition.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.weather.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.translate.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        

        /* TEST */
        /*
        {key: "glasschain.app.host.addr", value: "https://observations-test.glasschain.net"},
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-east.azurewebsites.net"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-east.azurewebsites.net"},
        {key: "glasschain.core.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.address.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.translation.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.textrecognition.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.weather.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.translate.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        */

        /* DEV */
        /*
        //{key: "glasschain.app.host.addr", value: "http://localhost:3000"},
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-west-b7azgtemaebzdgh6.westus-01.azurewebsites.net"},
        //{key: "glasschain.auth.host.addr", value: "http://localhost:10001"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-west-c4e7fhggh6c7e2gf.westus-01.azurewebsites.net"},
        //{key: "glasschain.auth.resource.host.addr", value: "http://localhost:10005"},
    
        {key: "glasschain.core.host.addr", value: "http://localhost:6013"},
        //{key: "glasschain.core.host.addr", value: "https://gc-itemtracer-core-hfdwf2f6ebc4c7ah.eastus-01.azurewebsites.net"},
        {key: "glasschain.address.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.translation.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.textrecognition.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.weather.host.addr",  value: "http://localhost:6013"},
        {key: "glasschain.translate.host.addr",value: "http://localhost:6013"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "http://localhost:6013"},
        */
    


    /* SHARED */
    {key: "base.user.scope", value: ["itrace.app.user", "auth.role.reader"]}, 
    {key: "glasschain.api.usebearertoken", value: true},
    {key: "userguide.file.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/{gcid}/userguides/"},
    {key: "userguide.file.name", value: "glasschain-itemtracer-userguide.pdf"},
    {key: "default.email.from.address", value: "support.com"},
    {key: "glasschain.image.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/"},
    {key: "glasschain.image.common.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gc-images/common/"},
    {key: "glasschain.gcid.slide.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userimg.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userdoc.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userrpt.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.report.host.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid"},
    {key: "lot.watch.interval.milliseconds", value: 60000},
    {key: "system.app.prefix", value: "itrace"},
    {key: "user.roles", value: [{id: "itrace.dashboard.admin", displayName: "itrace.dashboard.admin"}, {id: "itrace.dashboard.user", displayName: "itrace.dashboard.user"}]},
    {key: "system.roles", value: ["glassbit.support", "SharedReportViewer"]},
    {key: "system.users", value: ["glassbit-support@glassbit.com",  "customer.adapter", "shared.report.viewer"]},
    {key: "system.lists", value: []},
    {key: "system.entities", value: []},
    {key: "dataApiRole", value: "ApiDataReader"},
    {key: "geolocation.options", value: {enableHighAccuracy: false, maximumAge: 0, timeout: 10000}},
    {key: 'google.vision.api.key', value: "AIzaSyCjQzBfEZveXkYcCVaoEzKhkaKJCVIfXMw"},
    {key: 'google.vision.api.host.addr', value: "https://vision.googleapis.com"},
    {key: "version", value: "05.04.05"}
]


module.exports = {
    appsettings
}